import React, { useEffect, useState } from "react";

import { isUserLoggedIn } from "@/services/CookiesService";
import { SubscriptionPlansLogged } from "./SubscriptionPlansLogged";
import { SubscriptionPlansNotLogged } from "./SubscriptionPlansNotLogged";
import { PricingLoggedContainerProps } from "../types";
import { FaqsPricingContainer } from "../FaqsPricingContainer/FaqsPricingContainer";

import "./styles.scss";

export const PricingLoggedContainer = ({
  data,
  currentPlan,
  onSelectPlan,
  isStatusActive,
}: PricingLoggedContainerProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const [userLogged, setUserLogged] = useState(false);
  useEffect(() => {
    setIsMounted(true);
    setUserLogged(!!isUserLoggedIn());
  }, []);

  return (
    <>
      {isMounted && !userLogged ? (
        <SubscriptionPlansNotLogged
          data={data}
          currentPlan={currentPlan}
          onSelectPlan={onSelectPlan}
          isStatusActive={isStatusActive}
        />
      ) : (
        <SubscriptionPlansLogged
          data={data}
          currentPlan={currentPlan}
          onSelectPlan={onSelectPlan}
          isStatusActive={isStatusActive}
        />
      )}

      {isMounted && data.faqs && <FaqsPricingContainer data={data.faqs} />}
    </>
  );
};
